const actionTypeIdentifier = "BC7C77AF-6198-4DC5-9D71-B4BE2B641A4F";

export const setGlCodeHistoryLogsLoading = `SET-GL-CODE-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getGlCodeHistoryLogs = `GET-GL-CODE-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setGlCodeHistoryPageSize = `SET-GL-CODE-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetGlCodeHistory = `RESET-GL-CODE-HISTORY-${actionTypeIdentifier}`;
export const setGlCodeHistoryColSearchStr = `SET-GL-CODE-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;